import React, { useState, useContext } from "react";
import { Images } from "../../theme";
import "./styles.css";
import { AuthContext } from "../../context/AuthContext";
import { passwordRegex, DotsLoader } from "../../components";
import { useTranslation } from "react-i18next";

export default (props) => {
  const AuthData = useContext(AuthContext);
  const { reset_password, isLoading, handle_change_password } = AuthData
    ? AuthData
    : null;

  const { t } = useTranslation();

  const [current, setCurrent] = useState("");
  const [emailCode, setEmailCode] = useState("");
  const [newpass, setNewpass] = useState("");
  const [confirm, setConfirm] = useState("");
  const [formErrors, setFormErrors] = useState({
    emailError: false,
    passwordError: false,
  });

  const onChangeInput = async (data) => {
    data.state(data.value);
  };

  const checkValidation = () => {
    if (props.email && !emailCode) {
      setFormErrors({ formErrors, emailCodeError: t("Required_Code") });
    } else if (!props.email && !current) {
      setFormErrors({ formErrors, currentError: t("Current_Password") });
    } else if (!newpass) {
      setFormErrors({
        formErrors,
        newPassError: t("Required_Password"),
      });
    } else if (!newpass.match(passwordRegex)) {
      setFormErrors({
        formErrors,
        newPassError: t("Password_Limit"),
      });
    } else if (!confirm) {
      setFormErrors({
        formErrors,
        conformPassError: t("Required_Password"),
      });
    } else if (confirm != newpass) {
      setFormErrors({ formErrors, conformPassError: t("Password_Not_Match") });
    } else {
      let emailPayload = {
        email: props.email,
        password: newpass,
        password_confirmation: confirm,
        token: emailCode,
      };
      let resetPayload = {
        current_password: current,
        password: newpass,
        password_confirmation: confirm,
      };
      if (props.email) reset_password(emailPayload, props);
      else handle_change_password(resetPayload, props);
    }
  };

  const renderEmail = () => {
    return (
      <>
        {props.email ? (
          <div className="form-label-group mb-3">
            <div>
              <label>{t("Email_Code")}</label>
              <input
                className="input-field"
                value={emailCode}
                type="text"
                placeholder={t("Email_Code")}
                onChange={(e) => {
                  setFormErrors(false);
                  onChangeInput({
                    value: e.target.value,
                    state: setEmailCode,
                  });
                }}
              />
            </div>
            <div className="error_text">{formErrors.emailCodeError}</div>
          </div>
        ) : (
          <div className="form-label-group mb-3">
            <div>
              <label>{t("Current_Password")}</label>
              <input
                className="input-field"
                value={current}
                type="password"
                placeholder={t("Current_Password")}
                onChange={(e) => {
                  setFormErrors(false);
                  onChangeInput({
                    value: e.target.value,
                    state: setCurrent,
                  });
                }}
              />
            </div>
            <div className="error_text">{formErrors.currentError}</div>
          </div>
        )}
        <div className="form-label-group mb-3">
          <div>
            <label>{t("New_Password")}</label>
            <input
              className="input-field"
              value={newpass}
              type="password"
              placeholder={t("New_Password")}
              onChange={(e) => {
                setFormErrors(false);
                onChangeInput({
                  value: e.target.value,
                  state: setNewpass,
                });
              }}
            />
          </div>
          <div className="error_text">{formErrors.newPassError}</div>
        </div>
        <div className="form-label-group mb-3">
          <div>
            <label>{t("Confirm_Password")}</label>
            <input
              className="input-field"
              value={confirm}
              type="password"
              placeholder={t("Confirm_Password")}
              onChange={(e) => {
                setFormErrors(false);
                onChangeInput({
                  value: e.target.value,
                  state: setConfirm,
                });
              }}
            />
          </div>
          <div className="error_text">{formErrors.conformPassError}</div>
        </div>
      </>
    );
  };

  const renderLoginBtn = () => {
    return (
      <div className="pt-3" style={{ textAlign: "center" }}>
        <button
          type="button"
          className="btn-custom btn-light"
          style={{ width: "100%", borderRadius: 10, height: 50 }}
          disabled={isLoading}
          onClick={() => checkValidation()}
        >
          {isLoading ? (
            <DotsLoader isloading={isLoading} color="#E8F0F2" />
          ) : (
            t("Reset_Password")
          )}
        </button>
      </div>
    );
  };

  const renderLoginForm = () => {
    return (
      <form action="javascript:void(0)" className="form-signin mt-4 px-2">
        {renderEmail()}
        {renderLoginBtn()}
      </form>
    );
  };

  const renderLoginCard = () => {
    return (
      <div className="card card-signin my-2 border-0">
        <div className="card-body">
          <h5 className="card-title text-center heading_title">
            {t("Reset_Password")}
          </h5>
          {renderLoginForm()}
        </div>
      </div>
    );
  };

  return (
    <div className="bg">
      <div className="center">
        <div
          className="container"
          style={{
            backgroundImage: `url(${Images.bg_image})`,
            borderRadius: 28,
            backgroundColor: "#E5E5E5",
          }}
        >
          <div
            className="row"
            style={{
              paddingBottom: 50,
            }}
          >
            <div className="d-flex justify-content-center my-3">
              <img className="logo-icon" src={Images.logo_white} alt="image" />
            </div>

            <div className="col-sm-9 col-md-9 col-lg-5 mx-auto">
              {renderLoginCard()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
